import { Box, Flex, Image } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import TextComponent from "../../../components/Form/Text";
import Nav from "../../../components/UI/Navbar";
import Sidebar from "../../../components/UI/Sidebar";
import reporte from "../../../services/reporte";
import { DataTable } from "../../../components/HOC's/DataTable";
import SkeletonComponent from "../../../components/Form/Skeleton";
import CustomersArray from "../../../utils/TipoReporte";
import { createColumnHelper } from "@tanstack/react-table";
import * as FileSaver from "file-saver";
import * as XLSX from "sheetjs-style";
import ButtonComponents from "../../../components/Form/Button";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Select,
  Button,
  useToast,
} from "@chakra-ui/react";
import { FiFile } from "react-icons/fi";

export default function Reporte() {
  const [columns, setcolumns] = useState<any>([]);
  const [data, setdata] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [loading, setloading] = useState(false);
  const [update, setupdate] = useState(false);
  const [form, setform] = useState({
    nombre: "",
    status: "",
  });
  const toast = useToast();

  useEffect(() => {
    getData();
    return () => {};
  }, []);

  const getData = () => {
    reporte.tipoReporteGet().then((response) => {
      const columnHelper = createColumnHelper<any>();
      const columns = CustomersArray.Columns().map(({ title, campo }: any) => {
        return columnHelper.accessor(campo, {
          cell: (info: any) => info.getValue(),
          header: title ?? "",
        });
      });
      setcolumns(columns);
      const data = response.data;
      setdata(data);
    });
  };

  const ExportExcel = (array: any) => {
    const newArray = array.map((res: any) => {
      delete res.created_at;
      delete res.updated_at;
      delete res.id_user_zoho;
      return res;
    });
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const ws = XLSX.utils.json_to_sheet(newArray);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Reporte-general" + fileExtension);
  };

  const cleanForm = () => {
    setform({
      nombre: "",
      status: "",
    });
    setloading(false);
  };

  const guardarUsuario = () => {
    if (form.nombre === "") {
      toast({
        title: "Error!",
        description: "Todos los campos son obligatorios!",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    setloading(true);
    if (update) {
      reporte
        .tipoReporteUpdate(form)
        .then((response) => {
          setloading(false);
          if (!response.errors) {
            cleanForm();
            setOpen(false);
            getData();
            toast({
              title: "Correcto!",
              description: "Tipo de reporte actualizado correctamente!",
              status: "success",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
          } else {
            const errors = Object.keys(response.errors).map((key) => {
              return response.errors[key][0];
            });
            toast({
              title: "Error!",
              description: errors.join(", "),
              status: "error",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
        .catch((err) => {
          setloading(false);
          toast({
            title: "Error!",
            description: err.message,
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          });
        });
    } else {
      reporte
        .tipoReporteAdd(form)
        .then((response) => {
          setloading(false);
          if (!response.errors) {
            cleanForm();
            setOpen(false);
            getData();
            toast({
              title: "Correcto!",
              description: "Tipo de reporte creado correctamente!",
              status: "success",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
          } else {
            const errors = Object.keys(response.errors).map((key) => {
              return response.errors[key][0];
            });
            toast({
              title: "Error!",
              description: errors.join(", "),
              status: "error",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
        .catch((err) => {
          setloading(false);
          toast({
            title: "Error!",
            description: err.message,
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          });
        });
    }
  };

  return (
    <div>
      <Nav />
      <Sidebar>
        <Box bg={"white"} p={10} borderRadius={20}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Flex gridGap={3} alignItems={"center"}>
              <FiFile size={50} />
              <TextComponent
                color={"#f06e26"}
                fontSize={"3xl"}
                fontWeight={"bolder"}
                textAlign={"left"}
                text="Tipo de reporte"
                textTransform={"uppercase"}
              />
            </Flex>
            <Box>
              <Image
                src={"/stihl-logo.svg"}
                height={50}
              />
            </Box>
          </Box>

          <Box display={"flex"} justifyContent={"flex-end"} mt={5}>
            <ButtonComponents
              text="Crear tipo de reporte"
              color="#f06e26"
              onClick={() => {
                setOpen(true);
              }}
              size="sm"
            />
          </Box>

          <Box overflowX="auto" mt={4}>
            {data.length === 0 && <SkeletonComponent />}
            <DataTable
              columns={columns}
              data={data}
              edit={true}
              onOpenUpdate={() => {
                setOpen(true);
                setupdate(true);
              }}
              setArray={setform}
              ExportExcel={ExportExcel}
            />
          </Box>
        </Box>

        {open && (
          <Modal
            isOpen={open}
            onClose={() => {
              setOpen(false);
            }}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                {update ? "Actualizar usuario" : "Crear nuevo usuario"}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Box
                  bg={"white"}
                  p={5}
                  borderRadius={20}
                  gap={2}
                  display="flex"
                  flexDirection="column"
                >
                  <Input
                    type="text"
                    placeholder="Nombre"
                    value={form.nombre}
                    onChange={(e) =>
                      setform({ ...form, nombre: e.target.value })
                    }
                  />
                  {update && (
                    <Select
                      placeholder="Seleccione un estatus"
                      value={form.status}
                      onChange={(e) =>
                        setform({ ...form, status: e.target.value })
                      }
                    >
                      {["Activo", "Cancelado"].map((rol) => (
                        <option key={rol} value={rol}>
                          {rol}
                        </option>
                      ))}
                    </Select>
                  )}
                </Box>
              </ModalBody>
              <ModalFooter display="flex" gap={2}>
                <Button
                  colorScheme="red"
                  onClick={() => {
                    setOpen(false);
                  }}
                  size="md"
                >
                  Cancelar
                </Button>
                <Button
                  colorScheme="green"
                  onClick={guardarUsuario}
                  size="md"
                  isLoading={loading}
                >
                  Guardar
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        )}
      </Sidebar>
    </div>
  );
}
